import { render, staticRenderFns } from "./SVGAdminUsers.vue?vue&type=template&id=189d0c20&scoped=true&"
import script from "./SVGAdminUsers.vue?vue&type=script&lang=js&"
export * from "./SVGAdminUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189d0c20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('189d0c20')) {
      api.createRecord('189d0c20', component.options)
    } else {
      api.reload('189d0c20', component.options)
    }
    module.hot.accept("./SVGAdminUsers.vue?vue&type=template&id=189d0c20&scoped=true&", function () {
      api.rerender('189d0c20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGAdminUsers.vue"
export default component.exports